import * as React from "react";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import { Button, CardActions, makeStyles, Typography } from "@material-ui/core";
import { useDispatch } from "react-redux";
import { MenuItem } from "../../model/menu-model";
import { setSelectedItem, setShowDetail } from "../../slice/search-slice";

interface ItemCardProps {
  item: MenuItem;
}

const useStyles = makeStyles({
  root: {
    width: 450,
    height: 200,
    margin: 10,
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },
});

export default function MenuItemCard(props: ItemCardProps) {
  const { item } = props;
  const classes = useStyles();
  const dispatch = useDispatch();
  const openModel = () => {
    dispatch(setSelectedItem(item));
    dispatch(setShowDetail(true));
  };
  return (
    <Card className={classes.root}>
      <CardContent>
        <Typography variant="h5" component="h2">
          {item?.name}
        </Typography>

        <Typography variant="body2" component="p">
          {item.description}
        </Typography>
        <Typography className={classes.pos} color="textSecondary">
          ${item?.price?.toFixed(2)}
        </Typography>
      </CardContent>
      <CardActions>
        <Button variant="outlined" color="primary" onClick={openModel}>
          See Photo
        </Button>
      </CardActions>
    </Card>
  );
}
